<!-- index -->
<template>
  <div class="index">
    <div class="wxBox">
      <div class="mqBox">
        <img src="../../static/images/common/联系.jpg" alt="" />
        <div class="p">扫一扫，联系我们</div>
      </div>
    </div>
    <div class="bgBox section1">
      <div class="s1_innerBox">
        <div class="p p1">科技创新 <span></span>引领未来</div>
        <div class="line"></div>
        <div class="p p2">SCIENTIFIC AND TECHNOLOGICAL INNOVATION</div>
        <div class="p p3">LEADING THE FUTURE</div>
      </div>
    </div>
    <div class="bgBox section2 typeArea">
      <div class="topTitle centerTop">
        <div class="p1"><span>核心</span>竞争力</div>
        <div class="p2"></div>
        <div class="p3">CORE COMPETENCE</div>
      </div>
      <div class="bottom">
        <div class="item">
          <img src="../../static/images/index/核心1.png" alt="" />
          <div class="p1">全套自研熔炼技术</div>
          <div class="p2"></div>
          <div class="p3">
            深耕悬浮熔炼、高纯材料、半导体材料、储能合金材料、各型熔炼炉等技术
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/index/核心2.png" alt="" />
          <div class="p1">悬浮熔炼技术强</div>
          <div class="p2"></div>
          <div class="p3">
            熔池驼峰的高/径比=2.0~3.0,在熔炼过程中凝壳很少，最高熔炼温度可达3600℃
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/index/核心3.png" alt="" />
          <div class="p1">结合多种现代化技艺</div>
          <div class="p2"></div>
          <div class="p3">
            离心铸、底铸、吸铸、连续拉锭、电弧熔炼、等离子熔炼等
          </div>
        </div>
        <div class="item">
          <img src="../../static/images/index/核心4.png" alt="" />
          <div class="p1">强大的创新研究能力</div>
          <div class="p2"></div>
          <div class="p3">
            教授、高工和归国专家6人，海外归国博士5人，以专家为核心建立了研究所——公司技术开发的基地
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3">
      <div class="s3_innerBox typeArea">
        <div class="topTitle leftTop">
          <div class="p1"><span>业务</span>介绍</div>
          <div class="p2"></div>
          <div class="p3">OUR BUSINESS</div>
        </div>
        <div class="bottom">
          <div class="item item1">
            <div class="innerBox">
              <img src="../../static/images/index/专业熔炼设备.jpg" alt="" />
              <div class="p1">专业熔炼设备</div>
              <div class="p2"></div>
              <div class="p3">PROFESSIONAL MELTING EQUIPMENT</div>
            </div>

            <div class="p4">
              <div class="p1">专业熔炼设备</div>
              <div class="p2"></div>
              <div class="p3">PROFESSIONAL MELTING EQUIPMENT</div>
              <div class="p44">
                赛迈特熔炼设备具有悬浮能力强，熔炼温度高，规格范围广，结合多种现代技术，延长坩埚寿命，提高运行效率，改善合金均匀性，实现数字化、智能化操作等领先技术
              </div>
              <div class="p55" @click="linkFunc('/smeltingEquipment')">
                了解更多 >
              </div>
            </div>
          </div>
          <div class="item item2">
            <div class="innerBox">
              <img src="../../static/images/index/悬浮冶金.jpg" alt="" />
              <div class="p1">悬浮熔炼冶金</div>
              <div class="p2"></div>
              <div class="p3">LEVITATION MELTING</div>
            </div>

            <div class="p4">
              <div class="p1">悬浮熔炼冶金</div>
              <div class="p2"></div>
              <div class="p3">LEVITATION MELTING</div>
              <div class="p44">
                悬浮熔炼冶金具有无污染，温度高，成分均匀，具有铸造功能等优点；这种技术适合于制备高纯金属，活泼金属，难熔金属，贵金属，以及成分复杂，技术要求高的合金
              </div>
              <div class="p55" @click="linkFunc('/metallurgy')">了解更多 ></div>
            </div>
          </div>
          <div class="item item3">
            <div class="innerBox">
              <img src="../../static/images/index/材料研制.jpg" alt="" />
              <div class="p1">新材料研制</div>
              <div class="p2"></div>
              <div class="p3">RESEARCH NEW MATERIALS</div>
            </div>

            <div class="p4">
              <div class="p1">新材料研制</div>
              <div class="p2"></div>
              <div class="p3">RESEARCH NEW MATERIALS</div>
              <div class="p44">
                利用高端熔炼设备领域的技术领先优势，赛迈特提供量身定做的高端材料制备生产服务，熔炼的材料都是用其它材料制备手段无法获得或很难获得的技术难度极高的材料
              </div>
              <div class="p55" @click="linkFunc('/materialDev')">
                了解更多 >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section4">
      <div class="s4_innerBox typeArea">
        <div class="topTitle rightTop">
          <div class="p1">公司<span>团队</span></div>
          <div class="p2"></div>
          <div class="p3">OUR TEAM</div>
          <img src="../../static/images/index/公司团队.jpg" alt="" />
        </div>
        <div class="pBox">
          教授、高工和归国专家6人，海外归国博士5人，以专家为核心建立了研究所——公司技术开发的基地。
        </div>
        <div class="pBox">
          2019年，在赛迈特公司内建设了与哈工大合作的新材料联合开发实验室。
        </div>
        <div class="blockBox">
          <div class="left">
            <div class="item item1">
              <div class="p1">企业经营宗旨</div>
              <div class="p2"></div>
              <div class="p3">Our Tenet</div>
              <div class="p4">产品质量为首、客户利益至上</div>
            </div>
            <div class="flx">
              <div class="item item2">
                <div class="p1">愿景</div>
                <div class="p2"></div>
                <div class="p3">Our Vision</div>
                <div class="p4">打造国内领先的新材料创新平台</div>
              </div>
              <div class="item item3">
                <div class="p1">核心价值观</div>
                <div class="p2"></div>
                <div class="p3">Our Core values</div>
                <div class="p4">以人为本、产研结合、服务至上</div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="item item4">
              <div class="p1">使命</div>
              <div class="p2"></div>
              <div class="p3">Our Mission</div>
              <div class="p4">助力科研，服务产业</div>
            </div>
            <div class="item item5">
              <div class="p1">文化</div>
              <div class="p2"></div>
              <div class="p3">Our Culture</div>
              <div class="p4">专业 • 勤奋• 务实• 感恩</div>
            </div>
          </div>
        </div>
        <div class="more" @click="linkFunc('/about')">了解更多 ></div>
      </div>
    </div>
    <div class="bgBox section5">
      <div class="s5_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1"><span>客户</span>案例</div>
          <div class="p2"></div>
          <div class="p3">OUR CUSTOMER</div>
          <div class="pBox">设备得到国内外顶尖科研机构和企业客户的认可</div>
        </div>
        <div class="textBox">
          <div class="p">
            中国工程物理研究院、中国核动力研究设计院、中国科学院金属研究所、中国科学院合肥物质科学研究所、中国科学院宁波材料技术与工程研究所、中国科学院长春应用化学研究所、中国科学院力学研究所、北京有色金属研究总院、广州有色金属研究院、湖南稀土金属材料研究院、中国船舶重工集团第七二研究所、中国机械总院集团沈阳铸造研究所、昆明贵金属研究院等院所;
          </div>
          <div class="p">
            清华大学、北京大学、哈尔滨工业大学、北京航空航天大学、北京科技大学、北京工业大学、上海大学、上海理工大学、上海交通大学、南京工业大学、南京理工大学、南京航空航天大学、西安交通大学、西北工业大学、厦门大学、福州大学、渤海大学、郑州大学、中南大学、中北大学、南方科技大学
            、哈尔滨工业大学深圳科技创新研究院、华南理工大学、重庆大学、长安大学、华中科技大学、太原理工大学、河北科技大学、大连理工大学、合肥工业大学、浙江大学、衢州学院等高校;
          </div>
          <div class="p">
            华为技术有限公司、昆明富尔诺林科技发展有限公司、瑞声光电科技(常州)有限公司、东莞宜安科技股份有限公司、中国核工业总公司第四零四厂、湖南顶立科技有限公司、攀钢集团有限公司、福建省长汀金龙稀土有限公司、中国东方航空股份有限公司、株洲硬质合金集团有限公司、北京合纵科技股份有限公司、广西瀚航稀土科技有限公司、沈阳东创机械装备有限公司、深圳市福摩索金属制品有限公司、西安耐百特电力储能科技股份有限公司、先导薄膜材料(广东)有限公司、山东通裕集团有限公司、湖南莱茵网络科技有限公司、厚普清洁能源(集团)股份有限公司等高科技企业
            ;
          </div>
          <div class="p">
            以及TOSOH SMD,INC.的美国公司和日本公司，韩国的INCO
            Korea等国外公司，还有香港理工香港大学、台湾的国立清华大学和泰汶股份、光洋应用材料等港台的高校和企业。
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section6">
      <div class="s6_innerBox typeArea">
        <div class="item">
          <div class="itTop">220+</div>
          <div class="itBottom">定制熔炼设备</div>
        </div>
        <div class="item">
          <div class="itTop">30000+</div>
          <div class="itBottom">提供熔炼服务</div>
        </div>
        <div class="item">
          <div class="itTop">3500+</div>
          <div class="itBottom">提供技术支持</div>
        </div>
      </div>
    </div>
    <div class="bgBox section7">
      <div class="s7_innerBox typeArea">
        <div class="itemBox">
          <div class="item">
            <img src="../../static/images/index/清华.jpg" alt="" />
          </div>
          <div class="item">
            <img src="../../static/images/index/南工.jpg" alt="" />
          </div>
          <div class="item">
            <img src="../../static/images/index/北科.jpg" alt="" />
          </div>
          <div class="item">
            <img src="../../static/images/index/有研.jpg" alt="" />
          </div>
          <div class="item">
            <img src="../../static/images/index/稀土.jpg" alt="" />
          </div>
          <div class="item">
            <img src="../../static/images/index/计量.jpg" alt="" />
          </div>
          <div class="item">
            <img src="../../static/images/index/铸造.jpg" alt="" />
          </div>
          <div class="item">
            <img src="../../static/images/index/核动力.jpg" alt="" />
          </div>
          <div class="item">
            <img src="../../static/images/index/工程.jpg" alt="" />
          </div>
        </div>
        <div class="more" @click="linkFunc('/materialDev')">了解更多 ></div>
      </div>
    </div>
    <div class="bgBox section8">
      <div class="s8_innerBox typeArea">
        <div class="p1"></div>
        <div class="p2">
          <span class="span1">创新材料</span>
          <span>引领未来</span>
        </div>
        <div class="p3"></div>
        <div class="p4">
          — —致力于为客户提供优质的服务与悬浮冶金研发新材料解决方案— —
        </div>
        <div class="p5" @click="linkFunc('/contact')">联系我们 ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  mounted() {},
  methods: {
    linkFunc(data) {
      this.$router.push({
        path: data,
      }); // 关于我们
    },
  },
};
</script>

<style lang='less' scoped>
.index {
  width: 100%;
  min-width: 1200px;
  position: relative;
  .wxBox {
    position: fixed;
    z-index: 101;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 55px;
    height: 50px;
    border-radius: 25px 0 0 25px;
    cursor: pointer;
    background: url("../../static/images/common/微信客服.png") no-repeat center
      center;
    background-color: #c30000;
    .mqBox {
      position: absolute;
      right: 65px;
      top: 0;
      width: 120px;
      height: 154px;
      padding-top: 5px;
      background-color: #ffffff;
      display: none;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.35);
      img {
        width: 120px;
        height: 120px;
      }
      .p {
        font-size: 12px;
        color: #999999;
        margin-top: -8px;
      }
    }
  }
  .wxBox:hover {
    .mqBox {
      display: block;
    }
  }
  .section1 {
    width: 100%;
    height: 862px;
    background: url("../../static/images/index/banner.jpg") no-repeat;
    background-position: center;

    .s1_innerBox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 320px;
      text-align: left;

      .p {
        font-size: 32px;
        color: #545454;
      }

      .p1 {
        font-size: 80px;
        color: #333333;
        font-weight: 700;
        display: flex;
        align-items: center;

        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          margin: 0 20px;
          background-color: #c30000;
          border-radius: 50%;
        }
      }

      .line {
        width: 200px;
        height: 8px;
        background-color: #c30000;
        margin-top: 20px;
        margin-bottom: 40px;
      }

      .p2,
      .p3 {
        line-height: 50px;
        font-weight: 700;
      }
    }
  }

  .section2 {
    height: 890px;

    .bottom {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 90px;

      .item {
        width: 260px;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 164px;
          height: 164px;
        }

        .p1 {
          color: #333333;
          font-weight: 700;
          margin-top: 60px;
          font-size: 18px;
          line-height: 18px;
        }

        .p2 {
          width: 50px;
          height: 4px;
          background-color: #c30000;
          margin: 20px 0;
        }

        .p3 {
          font-size: 16px;
          color: #545454;
          font-weight: 400;
          line-height: 26px;
        }
      }
    }
  }

  .section3 {
    width: 100%;
    height: 867px;
    background: url("../../static/images/index/业务背景.jpg") no-repeat;
    background-position: center;

    .s3_innerBox {
      text-align: left;

      .bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 87px;

        .item {
          width: 360px;
          height: 450px;
          background-color: #ffffff;
          box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          overflow: hidden;

          .innerBox {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            overflow: hidden;
          }

          img {
            width: 360px;
            height: 331px;
            background-color: #ffffff;
          }

          .p1 {
            font-size: 24px;
            line-height: 24px;
            color: #555555;
            margin-top: 23px;
          }

          .p2 {
            width: 50px;
            height: 4px;
            background-color: #c30000;
            margin: 20px 0;
          }

          .p3 {
            font-size: 16px;
            line-height: 16px;
            color: #555555;
            font-weight: 400;
          }

          .p4 {
            transition: all 0.3s;
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(195, 0, 0, 0.8);
            box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);
            display: flex;
            flex-direction: column;
            align-items: center;

            .p1 {
              margin-top: 30px;
            }

            .p1,
            .p3 {
              color: #ffffff;
            }

            .p2 {
              background-color: #fff;
            }

            .p44 {
              margin-top: 22px;
              font-size: 16px;
              line-height: 28px;
              color: #ffffff;
              padding: 0 27px;
              position: relative;
            }

            .p55 {
              font-size: 14px;
              color: #ffffff;
              position: absolute;
              bottom: 35px;
              left: 50%;
              transform: translateX(-50%);
              cursor: pointer;
            }
          }
        }

        .item1:hover {
          background-image: url("../../static/images/index/业务1-选中.jpg");

          .innerBox {
            display: none;
          }

          .p4 {
            top: 0;
          }
        }

        .item2:hover {
          background-image: url("../../static/images/index/业务2-选中.jpg");

          .innerBox {
            display: none;
          }

          .p4 {
            top: 0;
          }
        }

        .item3:hover {
          background-image: url("../../static/images/index/业务3-选中.jpg");

          .innerBox {
            display: none;
          }

          .p4 {
            top: 0;
          }
        }
      }
    }
  }

  .section4 {
    margin-top: 270px;
    width: 100%;
    height: 1018px;
    background-color: #fbfbfb;

    .s4_innerBox {
      position: relative;
      height: 100%;

      .topTitle {
        margin-bottom: 100px;

        .p1 {
          margin-top: 0;
        }

        img {
          position: absolute;
          top: -64px;
          right: 500px;
          height: 200px;
        }
      }

      .pBox {
        text-align: center;
        font-size: 16px;
        line-height: 38px;
        color: #545454;
        font-weight: 400;
      }

      .blockBox {
        width: 510px;
        width: 100%;
        margin-top: 43px;
        display: flex;

        .item {
          background-color: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 250px;
          border: 2px solid #fff;

          .p1 {
            font-size: 24px;
            line-height: 24px;
            color: #555555;
            margin-top: 90px;
            transition: all 0.3s;
          }

          .p2 {
            width: 50px;
            height: 4px;
            background-color: #c30000;
            margin: 20px 0;
          }

          .p3 {
            font-size: 16px;
            line-height: 16px;
            color: #555555;
            font-weight: 400;
          }

          .p4 {
            font-size: 16px;
            line-height: 16px;
            color: #555555;
            font-weight: 400;
            margin-top: 33px;
            visibility: hidden;
          }
        }

        .item:hover {
          border: 2px solid #c30000;
          .p1 {
            margin-top: 60px;
          }

          .p4 {
            visibility: initial;
          }
        }

        .left {
          width: 795px;
          margin-right: 10px;
          height: 100%;
          display: flex;
          flex-wrap: wrap;

          .item1 {
            width: 100%;
          }

          .flx {
            margin-top: 10px;
            display: flex;
            width: 100%;
            flex-direction: row;
            justify-content: space-between;
          }

          .item2 {
            width: 392px;
          }

          .item3 {
            width: 392px;
          }
        }

        .right {
          width: 392px;
          height: 100%;

          .item4 {
            margin-bottom: 10px;
          }
        }
      }

      .more {
        width: 120px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border: solid 1px #c30000;
        position: absolute;
        bottom: 84px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 14px;
        color: #c30000;
        cursor: pointer;
      }
    }
  }

  .section5 {
    width: 100%;
    padding-bottom: 40px;
    .s5_innerBox {
      position: relative;
      height: 100%;

      .topTitle {
        .p1 {
          margin-top: 220px;
        }
      }

      .pBox {
        background-color: #c30000;
        font-size: 20px;
        color: #ffffff;
        line-height: 44px;
        padding: 0 18px;
        width: fit-content;
        margin: 40px 0;
      }

      .textBox {
        text-align: left;

        .p {
          font-size: 16px;
          line-height: 28px;
          font-weight: 400;
          color: #545454;
        }
      }
    }
  }

  .section6 {
    height: 183px;
    width: 100%;
    background-color: #fbfbfb;

    .s6_innerBox {
      position: relative;
      height: 100%;
      display: flex;
      justify-content: space-between;

      .item {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .itTop {
          font-size: 60px;
          line-height: 60px;
          font-weight: 700;
          color: #c30000;
        }

        .itBottom {
          margin-top: 25px;
          font-size: 16px;
          line-height: 16px;
          color: #545454;
          text-align: left;
        }
      }
    }
  }

  .section7 {
    height: 780px;
    width: 100%;
    margin-top: 32px;
    background-color: #fbfbfb;

    .s7_innerBox {
      position: relative;
      height: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .itemBox {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        height: 620px;
      }

      .item {
        width: 395px;
        height: 200px;
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          // width: 312px;
          height: auto;
        }
      }

      .more {
        width: 120px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border: solid 1px #c30000;
        position: absolute;
        bottom: 84px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 14px;
        color: #c30000;
        cursor: pointer;
      }
    }
  }

  .section8 {
    height: 780px;
    height: 400px;
    margin-top: 119px;
    margin-bottom: 160px;
    background: url("../../static/images/index/联系.jpg") no-repeat;
    background-position: center;

    .s8_innerBox {
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;

      .p1 {
        width: 500px;
        height: 4px;
        margin-top: 27px;

        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.1) 5%,
          rgba(183, 19, 19, 1) 20%,
          rgba(183, 19, 19, 1) 80%,
          rgba(255, 255, 255, 0.1) 95%,
          rgba(255, 255, 255, 0) 100%
        );
        background-blend-mode: normal, normal;
      }

      .p2 {
        font-size: 48px;
        line-height: 78px;
        font-weight: 700;
        color: #c30000;

        .span1 {
          margin-right: 24px;
        }
      }

      .p3 {
        width: 500px;
        height: 4px;
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.1) 6%,
          rgba(183, 19, 19, 1) 20%,
          rgba(183, 19, 19, 1) 80%,
          rgba(255, 255, 255, 0.1) 93%,
          rgba(255, 255, 255, 0) 100%
        );
        background-blend-mode: normal, normal;
      }

      .p4 {
        font-size: 36px;
        color: #333333;
        line-height: 200px;
      }

      .p5 {
        width: 120px;
        height: 32px;
        background-color: #c30000;
        font-size: 14px;
        color: #ffffff;
        line-height: 32px;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue